import styled from 'styled-components'
import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { ListItem } from 'components/shared/List/styles'
import { respondAbove } from 'styles/mediaQueries'

export const ZonesModalCategoryWrapper = styled(Box)`
    width: 100%;
    padding: 24px 16px;
    background: ${({ theme }) => theme.colors.grayscale_0};
    border: 1px solid ${({ theme }) => theme.colors.grayscale_300};
    border-radius: 8px;
    overflow: hidden;

    @media ${respondAbove.md} {
        padding: 32px 24px;
    }
`

export const ZonesCategoryInfo = styled(Box)`
    width: 286px;
`

export const ZonesCategoryIcon = styled.img`
    width: 48px;
    height: 36px;
    object-fit: contain;
`

export const ZonesCategoryBadge = styled(Text)`
    padding: 2px 8px;
    background: ${({ theme }) => theme.colors.secondary_100};
    border-radius: 4px;
`

export const ZonesCategoryList = styled(Box)`
    margin-top: 16px;

    ${ListItem}::before {
        margin-right: 8px;
        border-radius: 0;
        background-color: ${({ theme }) => theme.colors.grayscale_800};
    }
    ${Text} {
        font-size: 14px;
        line-height: 20px;
    }
`
